import { store, storeActions, preferences, Measurements } from '~/utility/BinSentry-ui-utility';
import { BnSubAction } from '../../common/bn-action';
import '../../common/bn-icon';

class UserUpdatePreferences extends BnSubAction {
  constructor() {
    super();
    this.actionname = 'update-preferences';
    this.submittext = 'Update';
  }

  static get properties() {
    return {
      group: { type: String },
    };
  }

  connectedCallback() {
    super.connectedCallback && super.connectedCallback();
    this.addEventListener('response', this._onResponse);
  }

  disconnectedCallback() {
    super.disconnectedCallback && super.disconnectedCallback();
    this.removeEventListener('response', this._onResponse);
  }

  _onResponse(e) {
    const { entity } = e.detail;
    const subEntity = entity.getSubEntityByClasses(['preferences', this.group]);
    const currentPrefs = preferences.get();
    currentPrefs[this.group] = { ...subEntity.properties };

    store.dispatch(storeActions.setPreferences(currentPrefs));

    preferences.flushCache();
    Measurements.flushCache();
  }
}

window.customElements.define('user-update-preferences', UserUpdatePreferences);
